/** Ngày giờ theo múi giờ Asia/Ho_Chi_Minh, định dạng Việt Nam. */
export const VN_TZ = 'Asia/Ho_Chi_Minh';

const dateFmt = new Intl.DateTimeFormat('en-GB', {
  timeZone: VN_TZ,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});
const dateTimeFmt = new Intl.DateTimeFormat('en-GB', {
  timeZone: VN_TZ,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

function toDate(v: string | Date): Date {
  if (v instanceof Date) return v;
  // Chuỗi yyyy-mm-dd thuần: hiểu là ngày lịch, không lệch múi giờ
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return new Date(`${v}T12:00:00+07:00`);
  return new Date(v);
}

/** -> "18/10/2026" ("" nếu rỗng) */
export function formatDateVi(v: string | Date | null | undefined): string {
  if (!v) return '';
  const dt = toDate(v);
  if (Number.isNaN(dt.getTime())) return '';
  return dateFmt.format(dt);
}

/** -> "18/10/2026 14:05" */
export function formatDateTimeVi(v: string | Date | null | undefined): string {
  if (!v) return '';
  const dt = toDate(v);
  if (Number.isNaN(dt.getTime())) return '';
  return dateTimeFmt.format(dt).replace(',', '');
}

/** Ngày hôm nay (yyyy-mm-dd) theo giờ Việt Nam. */
export function todayVN(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: VN_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
  return parts; // en-CA => yyyy-mm-dd
}

export function addDaysIso(iso: string, days: number): string {
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + days));
  return dt.toISOString().slice(0, 10);
}
